module.exports = __webpack_public_path__ + "media/images/your-privacy-choice-b484d5bb55ac778a4ce507b2c1562cfb.svg";